export default "__VITE_ASSET__CGSx5VQz__"